import { Check } from 'lucide-react';
import { forwardRef, type HTMLAttributes } from 'react';

import { cn } from '../../utils';
import { useMultiselectItemContext } from '../MultiselectInput.context';

export const MultiselectItemCheckbox = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => {
  const { selected } = useMultiselectItemContext();

  return (
    <div
      className={cn(
        'grid place-items-center h-4 w-4 border-[1.5px] border-grey-60 rounded-sm',
        selected && 'bg-primary-100 text-white border-none',
        className,
      )}
      ref={ref}
      {...props}
    >
      {selected ? <Check size={14} /> : null}
    </div>
  );
});
